import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import 'element-plus/dist/index.css'
import i18n from "@/core/plugins/i18n";
import { Vue3ProgressPlugin } from '@marcoschulte/vue3-progress';

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import VueApexCharts from 'vue3-apexcharts'; 
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'

library.add(fas)

import "@/core/plugins/prismjs";
import "bootstrap";

const app = createApp(App);
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(Vue3ProgressPlugin);
//app.use(VueApexCharts)
ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
